import { Sparkles } from "lucide-react";

export default function ComingSoonPage({ title, copy }) {
  return (
    <div className="mpd-page">
      <div className="mpd-page-head">
        <div>
          <p className="mpd-kicker">{title}</p>
          <h1>Coming soon</h1>
        </div>
      </div>
      <article className="mpd-card mpd-soon">
        <span className="mpd-soon-icon"><Sparkles size={22} /></span>
        <h2>{title}</h2>
        <p>{copy}</p>
      </article>
    </div>
  );
}
